import { Stats } from './stats';
import { User } from './user-model';

export type Identity = {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  user?: User;
  group: string | null;
  name: string;
  displayName: string | null;
  email?: string | null;
  emailVerified?: boolean;
  hasPassword?: boolean;
  tags: string[];
  lastLoginAt: Date | null;
  activated: boolean;
  locked?: boolean;

  /**
   * The provider accounts the identity can sign in with; included when
   * fetching a single identity
   */
  providers?: IdentityProviderAccount[];

  /**
   * The ids of the providers the identity can sign in with; included when
   * listing identities
   */
  linkedProviders?: string[];
};

export type IdentityProviderAccount = {
  provider: string;
  email: string | null;
  name: string | null;
  avatarUrl: string | null;
  createdAt: Date;
  lastLoginAt: Date | null;
};

/**
 * A password reset or email verification token issued for an identity
 *
 * The token is null if one couldn't be issued, e.g. a verification token for
 * an identity with no email address
 */
export type IdentityIssuedToken = {
  resetToken?: string | null;
  verificationToken?: string | null;
  expiresAt: Date | null;
  identity: Identity | null;
};

export type IdentityMinimal = {
  id: string;
  group: string | null;
  name: string;
};

export type IdentityStats = {
  events: Stats<{
    types: {
      [eventType: string]: number;
    };
  }>;
};

export const identityOrderFields = [
  'createdAt',
  'updatedAt',
  'userId',
  'group',
  'name',
  'displayName',
  'activated',
] as const;

export type IdentityOrderField = (typeof identityOrderFields)[number];
